import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useProviders } from '../../hooks/useProviders';

const ProviderList = () => {
  const [filters, setFilters] = useState({
    status: '',
    type: '',
    search: ''
  });

  const { providers, loading, error, deleteProvider } = useProviders(filters);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleDelete = async (id, name) => {
    if (window.confirm(`Are you sure you want to deactivate ${name}?`)) {
      try {
        await deleteProvider(id);
        alert('Provider deactivated successfully');
      } catch (err) {
        alert(err.message);
      }
    }
  };

  if (loading) return <div className="loading">Loading providers...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="provider-list">
      <div className="page-header">
        <h1>Freight Providers</h1>
        <Link to="/providers/new" className="btn btn-primary">
          Add Provider
        </Link>
      </div>

      <div className="filters">
        <input
          type="text"
          name="search"
          placeholder="Search providers..."
          value={filters.search}
          onChange={handleFilterChange}
          className="filter-input"
        />
        <select
          name="status"
          value={filters.status}
          onChange={handleFilterChange}
          className="filter-select"
        >
          <option value="">All Statuses</option>
          <option value="ACTIVE">Active</option>
          <option value="INACTIVE">Inactive</option>
          <option value="BLACKLISTED">Blacklisted</option>
        </select>
        <select
          name="type"
          value={filters.type}
          onChange={handleFilterChange}
          className="filter-select"
        >
          <option value="">All Types</option>
          <option value="FORWARDER">Forwarder</option>
          <option value="CARRIER">Carrier</option>
          <option value="BROKER">Broker</option>
        </select>
      </div>

      {providers.length === 0 ? (
        <div className="empty-state">
          <p>No providers found</p>
          <Link to="/providers/new" className="btn btn-primary">
            Add Your First Provider
          </Link>
        </div>
      ) : (
        <table className="provider-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Status</th>
              <th>Contact</th>
              <th>Reliability</th>
              <th>Response Time</th>
              <th>Quote Rate</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {providers.map((provider) => (
              <tr key={provider.id}>
                <td>
                  <Link to={`/providers/${provider.id}`} className="provider-name">
                    {provider.name}
                  </Link>
                </td>
                <td>
                  <span className={`badge badge-${provider.type.toLowerCase()}`}>
                    {provider.type}
                  </span>
                </td>
                <td>
                  <span className={`badge badge-${provider.status.toLowerCase()}`}>
                    {provider.status}
                  </span>
                </td>
                <td>
                  <div className="contact-info">
                    <div>{provider.contactName || 'N/A'}</div>
                    <div className="text-small">{provider.contactEmail}</div>
                  </div>
                </td>
                <td>
                  <div className="reliability-score">
                    <div className="score">{Math.min(100, Math.max(0, Number(provider.reliabilityScore) * 100)).toFixed(0)}%</div>
                    <div className="score-bar">
                      <div
                        className="score-fill"
                        style={{ width: `${Math.min(100, Math.max(0, Number(provider.reliabilityScore) * 100))}%` }}
                      />
                    </div>
                  </div>
                </td>
                <td>{Number(provider.averageResponseTime).toFixed(1)}h</td>
                <td>
                  {provider.quotesRequested > 0
                    ? `${provider.quotesReceived}/${provider.quotesRequested}`
                    : 'N/A'}
                </td>
                <td className="actions">
                  <Link to={`/providers/${provider.id}`} className="btn btn-sm btn-secondary">
                    View
                  </Link>
                  <Link to={`/providers/${provider.id}/edit`} className="btn btn-sm btn-secondary">
                    Edit
                  </Link>
                  {provider.status === 'ACTIVE' && (
                    <button
                      onClick={() => handleDelete(provider.id, provider.name)}
                      className="btn btn-sm btn-danger"
                    >
                      Deactivate
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ProviderList;
